import React from "react";
import { 
  Dialog, DialogTitle, DialogContent, DialogActions, 
  Typography, Button, Divider, IconButton 
} from "@mui/material";
import { Close } from "@mui/icons-material";

const ConfirmDeleteModal = ({ open, onClose, onConfirm }) => (
  <Dialog 
    open={open} 
    onClose={onClose}
    PaperProps={{ sx: { borderRadius: "8px", width: "100%", maxWidth: "450px" } }}
  >
    <DialogTitle sx={{ fontWeight: "bold", display: "flex", justifyContent: "space-between", alignItems: "center", p: 2 }}>
      ¿Eliminar elemento?
      <IconButton onClick={onClose} size="small"><Close /></IconButton>
    </DialogTitle>
    <Divider />
    <DialogContent sx={{ py: 3 }}>
      <Typography variant="body1" sx={{ color: "#050505" }}>
        ¿Estás seguro de que quieres eliminar esta información de tu perfil?
      </Typography>
    </DialogContent>
    <DialogActions sx={{ p: 2, bgcolor: "#f0f2f5" }}>
      <Button 
        onClick={onClose} 
        sx={{ color: "#1877f2", textTransform: "none", fontWeight: "bold" }}
      >
        Cancelar
      </Button>
      <Button 
        onClick={onConfirm} 
        variant="contained" 
        sx={{ bgcolor: "#1877f2", textTransform: "none", fontWeight: "bold", px: 4, "&:hover": { bgcolor: "#166fe5" } }}
      >
        Confirmar
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDeleteModal;